import { get, post, del, put } from '@api/request';
import { defaultPageSize } from '@constants';

export async function fetchSearchOptions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/ownersearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchOwner(
  { appraisalService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisal/owner/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  return body;
}

export async function fetchFields({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/config/ownersearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTags({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/owner/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwner(
  { appraisalService },
  authenticationToken,
  { ownerId },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addOwnerNumber(
  { appraisalService },
  authenticationToken,
  { ownerId, payload },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/phonenumbers`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchAllOwnerNumbers(
  { appraisalService },
  authenticationToken,
  { ownerId },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/phonenumbers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteOwnerNumber(
  { appraisalService },
  authenticationToken,
  { phoneID },
) {
  const url = `${appraisalService}/appraisal/ownerphonenumber/${phoneID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateOwnerNumber(
  { appraisalService },
  authenticationToken,
  { phoneID, payload },
) {
  const url = `${appraisalService}/appraisal/ownerphonenumber/${phoneID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchOwnerTags(
  { appraisalService },
  authenticationToken,
  { ownerID },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerID}/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwnerNotes(
  { appraisalService },
  authenticationToken,
  { ownerId },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchOwnerProperties(
  { appraisalService },
  authenticationToken,
  { ownerId },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/property`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteOwnerNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/ownernote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateOwnerNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/ownernote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function addOwnerNote(
  { appraisalService },
  authenticationToken,
  { id, data },
) {
  const url = `${appraisalService}/appraisal/owner/${id}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function validateOwner(
  { appraisalService },
  authenticationToken,
  { ownerId, data },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/casscertification`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function validateOwnerAddress(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/addresscasscertification`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateOwner(
  { appraisalService },
  authenticationToken,
  { ownerId, data },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createOwner(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/owners`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function updateOwnerTag(
  { appraisalService },
  authenticationToken,
  { ownerId, data },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerId}/tags`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function insertOwnerTag(
  { appraisalService },
  authenticationToken,
  { ownerID, data },
) {
  const url = `${appraisalService}/appraisal/owner/${ownerID}/tags`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function deleteOwnerTag(
  { appraisalService },
  authenticationToken,
  { tagID },
) {
  const url = `${appraisalService}/appraisal/owner/tag/${tagID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export const fetchCodefileOwnerTags = async (
  { appraisalService },
  authenticationToken,
) => {
  const url = `${appraisalService}/appraisal/codes?type=Owner&name=Tags`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function lookupOwner(
  { appraisalService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisal/owner/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  return body;
}

export async function fetchOwnerExemptionListing(
  { appraisalService },
  authenticationToken,
  { propertyIds },
) {
  const url = `${appraisalService}/appraisal/propertyownerexemptionlisting`;
  const { body } = await post(authenticationToken, url, propertyIds);
  return body;
}

// Ownership Transfer
export async function fetchPropertyListing(
  { appraisalService },
  authenticationToken,
  { pIds },
) {
  const url = `${appraisalService}/appraisal/propertylisting`;
  const { body } = await post(authenticationToken, url, pIds);
  return body;
}

export async function fetchPropertyOwnerListing(
  { appraisalService },
  authenticationToken,
  { pIds },
) {
  const url = `${appraisalService}/appraisal/propertyownerlisting`;
  const { body } = await post(authenticationToken, url, pIds);
  return body;
}

export async function postOwnershipTransfer(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/transferownership`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchOwnerEvents(
  { eventService },
  authenticationToken,
  { ownerID },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${ownerID}`,
    dataObject: 'owner',
  });
  return body;
}

export async function fetchOwnerGroups(
  { appraisalService },
  authenticationToken,
  { ownerGroupID },
) {
  const url = `${appraisalService}/appraisal/ownergroup/${ownerGroupID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addOwnerGroup(
  { appraisalService },
  authenticationToken,
  { ownerGroupID, payload },
) {
  const url = `${appraisalService}/appraisal/ownergroup/${ownerGroupID}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function setPrimaryOwnerGroup(
  { appraisalService },
  authenticationToken,
  { ownerGroupID, payload },
) {
  const url = `${appraisalService}/appraisal/ownergroup/${ownerGroupID}/setprimary`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function createOwnerGroup(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/ownergroups`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteOwnerGroup(
  { appraisalService },
  authenticationToken,
  { ownerGroupID, ownerID },
) {
  const url = `${appraisalService}/appraisal/ownergroup/${ownerGroupID}/${ownerID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function addOrCreateOwnerGroup(
  { appraisalService },
  authenticationToken,
  { payload },
) {
  const url = `${appraisalService}/appraisal/ownergroups/createoradd`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchOwnerNameAliases(
  { appraisalService },
  authenticationToken,
  { ownerID }
) {
  let url = `${appraisalService}/appraisal/owneralternatenames/${ownerID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function createOwnerNameAlias(
  { appraisalService },
  authenticationToken,
  { ownerID, payload }
) {
  let url = `${appraisalService}/appraisal/owneralternatenames/${ownerID}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchOwnerNameAlias(
  { appraisalService },
  authenticationToken,
  { alternateNamesID }
) {
  let url = `${appraisalService}/appraisal/owneralternatename/${alternateNamesID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateOwnerNameAlias(
  { appraisalService },
  authenticationToken,
  { alternateNamesID, payload }
) {
  let url = `${appraisalService}/appraisal/owneralternatename/${alternateNamesID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function deleteOwnerNameAlias(
  { appraisalService },
  authenticationToken,
  { alternateNamesID }
) {
  let url = `${appraisalService}/appraisal/owneralternatename/${alternateNamesID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function reorderOwnerAliasNames(
  { appraisalService },
  authenticationToken,
  { ownerID, payload },
) {
  const url = `${appraisalService}/appraisal/owneralternatenames/${ownerID}/setorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchOwnerTaxOfficeValidation(
  { appraisalService },
  authenticationToken,
  { pid, pYear, pVersion = 0, pRollCorr = 0 }
) {
  let url = `${appraisalService}/appraisal/property/${pid}/${pYear}/${pVersion}/${pRollCorr}/ownertaxofficevalidation`;
  const { body } = await get(authenticationToken, url);
  return body;
}
